import React, { useEffect, useState } from "react";
import {
  Checkbox,
  TextField,
  Autocomplete
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDispatch } from "react-redux";
import { getDocumentTypeData } from "../../../../store/actions/documentAction";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function DocumentTypeCheckboxes({
  value,
  onChange,
  allowedTypes = [],
  disabled = false
}) {
  const dispatch = useDispatch();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    dispatch(getDocumentTypeData()).then(res => {
      setTypes(res?.data || []);
    });
  }, [dispatch]);

  const filteredTypes =
    allowedTypes.length > 0
      ? types.filter(t => allowedTypes.includes(t.abbrevation))
      : types;

  return (
    <Autocomplete
      options={filteredTypes}
      disabled={disabled}
      value={
        filteredTypes.find(
          t => t.abbrevation === value?.abbrevation
        ) || null
      }
      getOptionLabel={option => option.abbrevation}
      onChange={(e, selected) => {
        if (!selected) {
          onChange(null);
          return;
        }

        onChange({
          id: selected.id,
          code: selected.document_type_code,
          abbrevation: selected.abbrevation
        });
      }}
      renderInput={params => (
        <TextField
          {...params}
          size="small"
          label="Document Type"
          placeholder={
            allowedTypes.length > 1
              ? "Select BOL / POD / POP"
              : ""
          }
        />
      )}
    />
  );
}
